<ng-container *ngIf="!auth.user.mob_verified">
    <form *ngIf="!mob_num" #phoneverify="ngForm" (ngSubmit)="sendOTP(phoneverify)">
        <input type="number" name="mob_num" ngModel required>
        <button [disabled]="!phoneverify.valid" type="submit">Sent OTP</button>
    </form>
    
    <form *ngIf="mob_num" #otpverify="ngForm" (ngSubmit)="verifyOTP(otpverify)">
        <input type="number" name="otp" ngModel>
        <button [disabled]="!otpverify.valid" type="submit">Verify OTP</button>
    </form>
    
    <button (click)="changeNumber()">Change number</button>
</ng-container>

<ng-container *ngIf="auth.user.mob_verified">
    Mobile number already verified
</ng-container>